import { FC } from 'react';
import GirlStub from '#webImages/girl-stub.webp';
import { useStoryDetailContext } from '#advertStory/detail';
import storyDetailCss from '../assets/detail/story-detail.module.scss';

const StoryDetailPhoto: FC = () => {
  const { story } = useStoryDetailContext();

  let src = story.photoUrl;
  if (!src) {
    src = GirlStub;
  }

  return <img className={storyDetailCss.storyDetail__photo} src={src} />;
};

export { StoryDetailPhoto };
